import React from 'react';
import { useListShopifyQuery } from 'modules/apps/apps/ShopifyApp/api/shopify.api';
import { Select } from 'antd';

const ShopifySelect = (props) => {
  const { onChange, value } = props; // Remove name since it's not used
  const { data = [], isFetching } = useListShopifyQuery();

  const handleChange = (value) => {
    onChange?.(value);
  };

  if (isFetching && !data) {
    return null;
  }

  return (
    <Select
      value={value || []}
      className='w-full'
      placeholder='Select Shopify'
      onChange={handleChange}
      mode='multiple'
    >
      {data.data?.map((opt) => {
        return (
          <Select.Option value={opt.id} label={opt.name} key={opt.id}>
            <div className='flex items-center'>
              <div className='flex gap-2 items-center justify-start pr-4'>{opt.name}</div>
            </div>
          </Select.Option>
        );
      })}
    </Select>
  );
};

export default ShopifySelect;
